import { createModulePerms } from '@wit-support/ui-domain';
/** Подсказка на закрытой правами кнопке (родной tooltip у disabled-кнопки нет — вешается на обёртку). */
export const NO_PERM_TITLE = 'Нет прав на это действие';
export const ADS_CAMPAIGNS_NO_PERMS = {
    canLaunch: false,
    canActivate: false,
};
const { Provider: AdsCampaignsModulePermsProvider, usePerms: useAdsCampaignsPerms } = createModulePerms(ADS_CAMPAIGNS_NO_PERMS);
export { AdsCampaignsModulePermsProvider, useAdsCampaignsPerms };
/** Флаги прав из списка ключей `me.permissions` — шелл зовёт это вместо ручного маппинга. */
export function adsCampaignsPermsFrom(can) {
    return {
        canLaunch: can('ads.launch'),
        canActivate: can('ads.activate'),
    };
}
//# sourceMappingURL=perms.js.map